import React from "react";
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Save from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Search from "@material-ui/icons/Search";

/**
 * search button
 */
export default function SearchButton({  onClick, label,icon, className, variant = "contained", ...props}) {

  const changeIcon = (icon) =>{
    switch(icon){
      case "add":
        return <Add/>
      case "edit":
        return <Edit/>
      case "save":
        return <Save/>
      case "search":
        return <Search/>
      default:
        return;
    }
  }
  return (
    <>
      <div/>
      <Button
        variant={variant}
        color="primary"
        className={className}
        size="large"
        startIcon={changeIcon(icon)}
        onClick={onClick}
        {...props}
      >
        {label}
      </Button>
    </>
  );
}
